import billingModule from '../../billing.module';
import template from './billingAction.component.html';
import style from './billingAction.component.css';

export default billingModule.component('billingAction', {
    template,
    style,
    bindings: {
        actionName: '@',
        actionLabel: '@',
        actionHref: '@',
        customClass: '<',
        resolve: '<',
        callback: '<'
    },
    controller(
        accountProvider,
        asLoadingMask,
        asNotifier,
        billingActionService,
        billingRequestService,
        billingSubscriptionService,
        modalService,
        textResources
    ) {
        var vm = this;

        vm.click = () => {
            switch (vm.actionName) {
                case 'subscription:change':
                    asLoadingMask.show();
                    accountProvider
                        .getAccountInfo()
                        .then(
                            data => {
                                if (data.Status == 1) {
                                    billingActionService.openModalProducts(
                                        vm.resolve,
                                        vm.callback
                                    );
                                } else if (data.Status == 2) {
                                    billingActionService.openModalResendActivationEmail(
                                        data.OwnerName,
                                        vm.resolve,
                                        vm.callback
                                    );
                                }
                            },
                            () => {
                                asNotifier.error(
                                    `${textResources.billingGetAccountInfo} ${
                                        textResources.ifProblemPersists
                                    }`
                                );
                            }
                        )
                        .finally(() => {
                            asLoadingMask.hide();
                        });
                    break;
                case 'payment-method:change':
                case 'payment-method:create':
                    billingActionService.openModalPayment(
                        vm.resolve,
                        vm.callback
                    );
                    break;
                case 'plan:request':
                    asLoadingMask.show();
                    billingSubscriptionService.getCurrentSubscription().then(
                        currentSubscription => {
                            billingRequestService
                                .submitRequest(
                                    currentSubscription,
                                    vm.resolve.plan
                                )
                                .then(
                                    () => {
                                        modalService.openCustom({
                                            component:
                                                'billingModalRequestPlan',
                                            size: 'md'
                                        });
                                    },
                                    () => {
                                        asNotifier.errorAndTryAgain(
                                            textResources.billingRequestPlanFailed
                                        );
                                    }
                                )
                                .finally(() => {
                                    asLoadingMask.hide();
                                });
                        },
                        () => {
                            asNotifier.errorAndTryAgain(
                                textResources.billingGetCurrentSubscriptionFailed
                            );
                        }
                    );

                    break;
                case 'plan:select':
                    asLoadingMask.show();
                    billingActionService
                        .hasAction('payment-method:create')
                        .then(
                            hasCreatePaymentMethodAction => {
                                if (hasCreatePaymentMethodAction) {
                                    billingActionService.openModalAddPayment(
                                        vm.resolve,
                                        vm.callback
                                    );
                                } else {
                                    billingActionService.openModalSelectPlan(
                                        vm.resolve,
                                        vm.callback
                                    );
                                }
                            },
                            () => {
                                asNotifier.errorAndTryAgain(
                                    textResources.billingGetActionsFailed
                                );
                            }
                        )
                        .finally(() => {
                            asLoadingMask.hide();
                        });
                    break;
                case 'payment:create':
                    asLoadingMask.show();

                    billingActionService
                        .hasAction('payment-method:create')
                        .then(
                            hasCreatePaymentMethodAction => {
                                if (hasCreatePaymentMethodAction) {
                                    billingActionService.openModalPayment(
                                        vm.resolve,
                                        vm.callback
                                    );
                                } else {
                                    billingActionService.openModalMakePayment(
                                        vm.resolve,
                                        vm.callback
                                    );
                                }
                            },
                            () => {
                                asNotifier.errorAndTryAgain(
                                    textResources.billingGetActionsFailed
                                );
                            }
                        )
                        .finally(() => {
                            asLoadingMask.hide();
                        });
                    break;
            }
        };
    }
});



// WEBPACK FOOTER //
// ./modules/billing/components/billing-action/billingAction.component.js